import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";

import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../snackbar";

export const CustomFileUpload = ({
  onUploadSuccess,
  label,
  defaultValue,
  helperText,
  allowedFormats = ["image/jpeg", "image/png", "image/jpg"],
  sx,
  ...props
}) => {
  const { showSnackbar } = useSnackbar();
  const [url, setUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setUrl(defaultValue);
    }
  }, [defaultValue]);

  const uploadImage = async (image) => {
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", image);

      const {
        data: { data },
      } = await apiClient.post("/files/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      onUploadSuccess(data.path);
      setUrl(data.previewUrl);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error)
      );
    } finally {
      setUploading(false);
    }
  };

  const onSelectFile = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    await uploadImage(event.target.files[0]);
  };

  return (
    <FormControl
      variant="standard"
      sx={{ ...(label && { pt: 3.5 }), ...sx }}
      {...props}
    >
      {label && (
        <InputLabel
          shrink
          sx={{
            fontSize: "0.875rem",
            lineHeight: "1.125rem",
            transform: "scale(1)",
          }}
        >
          {label}
        </InputLabel>
      )}
      <Stack direction="row" spacing={2}>
        <Typography variant="body2" color="textSecondary" sx={{ flex: 1 }}>
          Format foto harus .jpg, .jpeg, atau .png
        </Typography>
        <Box
          sx={{
            p: 1,
            width: 150,
            height: 150,
            border: "1px dashed grey",
            borderRadius: "8px",
            cursor: "pointer",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "#f1f1f1",
            },
          }}
          onClick={() => document.getElementById("file-upload").click()}
        >
          {uploading ? (
            (<CircularProgress size={24} />) // Show loading spinner when uploading
          ) : url ? (
            <img
              src={url}
              width={"100%"}
              height={"100%"}
              style={{
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />
          ) : (
            <Box>
              <CloudUploadIcon color="primary" />
              <Typography variant="body2">Pilih Gambar</Typography>
            </Box>
          )}
          <input
            id="file-upload"
            type="file"
            accept={allowedFormats.join(",")}
            onChange={onSelectFile}
            style={{ display: "none" }}
          />
        </Box>
      </Stack>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

CustomFileUpload.propTypes = {
  onUploadSuccess: PropTypes.func,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  helperText: PropTypes.string,
  allowedFormats: PropTypes.array,
  sx: PropTypes.object,
};
